import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'wp-sub-navigation-item',
  templateUrl: 'sub-navigation-item.component.html',
  styleUrl: 'sub-navigation-item.component.scss',
  imports: [RouterLink, RouterLinkActive],
})
export class SubNavigationItemComponent {
  @Input({ required: true }) public name!: string;
  @Input({ required: true }) public route!: string;
}
